import { ModalPrompt, Text } from "@repo/skapa";
import { t } from "@repo/translation";

import { FileLoadingEnum } from "../utils";

export const FileDeleteModal = ({
  fileId,
  loading,
  loadingFileId,
  onClose,
  onConfirm,
}: {
  fileId?: number;
  loading?: FileLoadingEnum;
  loadingFileId?: number;
  onClose: () => void;
  onConfirm: () => void;
}) =>
  fileId !== undefined ? (
    <ModalPrompt
      titleId="delete-file-modal-title"
      title={t("action.delete_file")}
      visible
      onClose={onClose}
      primaryButtonProps={{
        text: t("label.yes"),
        onClick: onConfirm,
        loading:
          loading === FileLoadingEnum.DELETING && loadingFileId === fileId,
      }}
      secondaryButtonProps={{
        text: t("label.no"),
        onClick: onClose,
      }}
    >
      <Text>{t("prompt.delete_file_confirm")}</Text>
    </ModalPrompt>
  ) : null;
